import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import TrashIcon from '@common/icons/TrashIcon';

const VcmUnitItem = ({ item, onDelete }) => {
  return (
    <Stack
      sx={{
        py: 1,
        px: 2,
        bgcolor: '#8686861A',
        border: '1px solid',
        borderColor: 'divider',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderRadius: '4px'
      }}
    >
      <Stack
        sx={{ flexDirection: 'row', flexGrow: 1, gap: 4, alignItems: 'center' }}
      >
        <Typography sx={{ flex: 1, minWidth: 0 }}>{item}</Typography>
      </Stack>
      <Stack>
        <IconButton onClick={onDelete}>
          <TrashIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default VcmUnitItem;
